import addRecipeView from './views/addRecipeView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import resultsView from './views/resultsView.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import * as model from './model.js';

import { MODAL_CLOSE_SEC } from './config.js';

import 'regenerator-runtime/runtime';
import 'core-js/stable';

import { async } from 'regenerator-runtime';

// Parcel Hot Module Replacement
// if (module.hot) module.hot.accept();

const controlRecipes = async () => {
  try {
    // Get ID from the URL
    const id = location.hash.slice(1);

    if (!id) return;

    // Update Results & Bookmarks (only the parts that changed)
    resultsView.update(model.getSearchResultsPage());
    bookmarksView.update(model.state.bookmarks);

    // Load new Recipe
    recipeView.renderSpinner();
    await model.loadRecipe(id);

    // Render new Recipe
    recipeView.render(model.state.recipe);
  } catch (err) {
    recipeView.renderError(err.message);
    console.error(err.message);
  }
};

const controlServings = newServings => {
  // Update the Recipe Servings
  model.updateServings(newServings);

  // Update the Recipe View (only the parts that changed)
  recipeView.update(model.state.recipe);
};

const controlStoredBookmarks = () =>
  bookmarksView.render(model.state.bookmarks);

const controlBookmarks = () => {
  // Add / Remove a Bookmark
  model.state.recipe.bookmarked ? model.removeBookmark() : model.addBookmark();

  // Update Recipe View
  recipeView.update(model.state.recipe);

  // Render Bookmarks
  bookmarksView.render(model.state.bookmarks);
};

const controlSearchResults = async () => {
  try {
    // Get Search Query
    const query = searchView.getQuery();
    if (!query) return;

    // Load Search Results
    resultsView.renderSpinner();
    await model.loadSearchResults(query);

    // Render Search Results & Pagination
    resultsView.render(model.getSearchResultsPage(1));
    paginationView.render(model.state.search);
  } catch (err) {
    resultsView.renderError(err.message);
    console.error(err.message);
  }
};

const controlPagination = newPage => {
  // Render New Results & Pagination
  resultsView.render(model.getSearchResultsPage(newPage));
  paginationView.render(model.state.search);
};

const resetModal = () =>
  setTimeout(() => location.reload(), MODAL_CLOSE_SEC * 1000);

const controlAddRecipe = async newRecipe => {
  try {
    // Render Loading Spinner
    addRecipeView.renderSpinner();

    // Upload New Recipe
    await model.uploadRecipe(newRecipe);

    // Render New Recipe
    recipeView.render(model.state.recipe);

    // Render Success Message
    addRecipeView.renderMessage();

    // Update Bookmarks
    bookmarksView.render(model.state.bookmarks);

    // Update ID in URL
    history.pushState(null, '', `#${model.state.recipe.id}`);

    // Close New Recipe Modal
    resetModal();
  } catch (err) {
    addRecipeView.renderError(err.message);
    console.error(err.message);
    resetModal();
  }
};

// Event Handlers in MVC:
// Publisher-Subscriber Pattern
const init = () => {
  bookmarksView.addHandlerRender(controlStoredBookmarks);
  paginationView.addHandlerClick(controlPagination);
  searchView.addHandlerSearch(controlSearchResults);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerBookmark(controlBookmarks);
  recipeView.addHandlerRender(controlRecipes);
  addRecipeView.addHandlerUpload(controlAddRecipe);
};

init();
